import script from "./ContactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactModal.vue?vue&type=script&setup=true&lang=js"

import "./ContactModal.vue?vue&type=style&index=0&id=b8812f28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8812f28"]])

export default __exports__